<template>
  <div class="animated fadeInRight">
    <el-row>
      <el-col :span="24">
        <div class="ibox">
          <div class="ibox-title">
            <h5>{{ $t('company.title') }}</h5>
            <div class="ibox-tools"></div>
          </div>
          <div class="ibox-content">
            <form id="component" class="wizard-big wizard clearfix" role="application" novalidate="novalidate">
              <p style="color: red;">{{ companyInfo.errorInfo }}</p>
              <div class="steps clearfix">
                <ul role="tablist">
                  <li role="tab" style="width:50%" :class="{ current: step==1, disabled:step!=1 }">
                    <a>{{ $t('company.shopInfo') }}</a>
                  </li>
                  <li role="tab" style="width:50%" :class="{ current: step==2, disabled:step!=2 }">
                    <a>{{ $t('company.notice') }}</a>
                  </li>
                </ul>
              </div>
              <div class="content clearfix">
                <h1 tabindex="-1" class="title current">{{ $t('company.basicInfo') }}</h1>
                <div :class="{no_display:step!=1}">
                  <company-base ref="companyBase"></company-base>
                </div>
                <h1 id="component-h-2" tabindex="-1" class="title">{{ $t('company.notice') }}</h1>
                <div :class="{no_display:step!=2}">
                  <company-readme ref="companyReadme"></company-readme>
                </div>
              </div>
              <div class="actions clearfix">
                <ul role="menu" aria-label="Pagination">
                  <li :class="{disabled:step == 1}" aria-disabled="true">
                    <a @click="previous()" role="menuitem">{{ $t('company.previous') }}</a>
                  </li>
                  <li :class="{no_display:step==2}">
                    <a @click="next()" role="menuitem">{{ $t('company.next') }}</a>
                  </li>
                  <li :class="{no_display:step!=2}">
                    <a @click="finish()" role="menuitem">{{ $t('company.submit') }}</a>
                  </li>
                </ul>
              </div>
            </form>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import CompanyBase from '@/components/common/companyBase/CompanyBase'
import CompanyReadme from '@/components/common/companyReadme/CompanyReadme'
import { replenishStoreAndShop } from '@/api/common/companyApi'

export default {
  name: 'Company',
  components: {
    CompanyBase,
    CompanyReadme
  },
  data() {
    return {
      step: 1,
      companyInfo: {
        name: "",
        shopName: '',
        areaAddress: '',
        address: "",
        tel: "",
        storeTypeCd: "800900000005",
        nearbyLandmarks: "无",
        areaCode: '',
        shopType: '',
        acceptTerms: false,
        errorInfo: ''
      }
    }
  },
  created() {
  },
  methods: {
    handleCompanyInfo(data) {
      Object.assign(this.companyInfo, data)
    },
    handleCompanyReadme(data) {
      Object.assign(this.companyInfo, data)
    },
    next() {
      if (this.step < 2) {
        this.step = this.step + 1
      }
    },
    previous() {
      if (this.step > 1) {
        this.step = this.step - 1
      }
    },
    async finish() {
      if (!this.validateAcceptTerms()) {
        this.$message.error(this.$t('company.pleaseReadNotice'))
        return
      }
      if (!this.companyInfo.acceptTerms) {
        this.$message.error(this.$t('company.agreeNoticeRequired'))
        return
      }

      try {
        const res = await replenishStoreAndShop(this.companyInfo)
        if (res.code === 0) {
          this.$router.push("/")
        } else {
          this.$message.error(res.msg)
        }
      } catch (error) {
        console.error('请求失败:', error)
        this.companyInfo.errorInfo = error.message
      }
    },
    validateAcceptTerms() {
      // 这里应该实现具体的验证逻辑
      return true
    }
  }
}
</script>

<style scoped>
.no_display {
  display: none;
}
.ibox {
  margin-bottom: 20px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
}
.ibox-title {
  border-bottom: 1px solid #e7eaec;
  padding: 15px 20px;
  min-height: 48px;
}
.ibox-content {
  padding: 20px;
}
.wizard-big .steps {
  margin-bottom: 20px;
}
.wizard-big .content {
  min-height: 150px;
}
.wizard-big .actions {
  padding: 20px 0;
  text-align: right;
}
</style>